import { TravelDocumentSalesModel } from 'api-hooks/sale/travel-document';
import useSalesActions from 'legacy-modules/sales/hooks/use-sales-actions';

import useDocumentSaleUpdateStatus from './use-document-sale-update-status';
import { DocumentSaleFormType } from '../components/form-type';

interface UseDocumentSaleActionsProps {
  data: TravelDocumentSalesModel;
  defaultValues: DocumentSaleFormType;
}

export default function useDocumentSaleActions(
  props: UseDocumentSaleActionsProps,
) {
  const type = 'document-sales' as const;
  const { data, defaultValues } = props;

  const { actionComponentPermission, ...rest } = useSalesActions({
    type,
    data,
    defaultValues,
  });

  const {
    revertStatusAction,
    updateNextDocumentComponent,
    updateBackDocumentStatusPermission,
    updateNextDocumentStatusPermissions,
    onUpdateNextStatus,
    onUpdatePreviousStatus,
    requestApprovalRevertDraftButton,
  } = useDocumentSaleUpdateStatus(data);

  const actions = [...rest.actions, revertStatusAction].filter(
    (action) => action.isAllowed,
  );
  return {
    ...rest,
    onUpdateNextStatus,
    onUpdatePreviousStatus,
    revertStatusAction,
    updateNextDocumentComponent,
    actionComponentPermission: {
      ...actionComponentPermission,
      updateBackDocumentStatusPermission,
      updateNextDocumentStatusPermissions,
    },
    actions,
    requestApprovalRevertDraftButton,
  };
}
